import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import type { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = sameValueForEveryLocale("/");

export function getHomepagePath(locale: Locale): string {
	return getPathInLocale(locale, pathMap);
}
